import React from 'react';
import { Form, Space, Radio, DatePicker, Input, InputNumber, Modal, message, Checkbox, Select, AutoComplete } from 'antd';
import { EProspectType, Meta, Prospect, TCarrier, TProspectInsurance } from 'types/common';
import { createProspect, updateProspect } from 'api/prospect';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import StateSelect from 'components/form/StateSelect';
import { findTargetMetaFromListByKey, formatDate } from 'utils/common';
import { FormProspect } from './types';
import GenderSelect from 'components/form/GenderSelect';
import dayjs from 'dayjs';
// import useMyListedChannels from 'hooks/useMyListedChannels';
import MyChannelSelect from 'components/form/MyChannelSelect';
import { REQUIRED_FIELD } from 'constants/common';
import UsPhoneInput from 'components/form/USPhoneInput';
import FormValidationHelper from 'utils/validation';
import useInsurance from 'hooks/useInsurance';
import useSettings from 'hooks/useSettings';
import { EnumFields } from 'types/enumerationData';
import FileUploadProspect from 'components/form/FileUploadProspect';
import FileUploadPrivate from 'components/form/FileUploadPrivate';
import useProviderServiceFlag from 'hooks/useProviderServiceFlag';
import BirthdayInput from 'components/form/BirthdayInput';

const InputTextArea = Input.TextArea;

type Props = {
    show: boolean,
    item?: Prospect,
    onCannel?: (needRefresh?: boolean) => void,
    onSuccess?: (id?: number) => void,
    wrapClassName?: string,
    type?: 1 | 2, // 1 basic info, 2 insurance info
};

enum EBillingType {
    SELF_PAY = 'Self-pay',
    INSURANCE = 'Insurance',
}

const BillingTypeOption = [
    {
        label: EBillingType.SELF_PAY,
        value: EBillingType.SELF_PAY,
    },
    {
        label: EBillingType.INSURANCE,
        value: EBillingType.INSURANCE,
    },
];

const TEXT_MESSAGE = 'Text message';
const PHONE_CALL = 'Phone call';
const EMAIL = 'Email';

const AddAndUpdateProspects = (props: Props) => {
    const { show, item, onCannel, onSuccess, wrapClassName, type } = props;
    const [submiting, setSubmiting] = React.useState(false);
    const [form] = Form.useForm<FormProspect>();
    const [isOthers, setIsOthers] = React.useState(false);
    const [setting, loading] = useSettings();
    const stateOption = setting[EnumFields.STATE] || [];
    const [flag] = useProviderServiceFlag();
    const isKlarity = !!flag?.klarityServiceFlag;

    const isEdit = !!item?.id;
    const [currentBillingType, setCurrentBillingType] = React.useState<EBillingType>();
    const [selfPayChecked, setSelfPayChecked] = React.useState(false);
    const [insuranceChecked, setInsuranceChecked] = React.useState(false);
    const [showSecondInsurance, setShowSecondInsurance] = React.useState(false);

    const [targetState, setTargetState] = React.useState<Meta>();
    const [targetCarrier, setTargetCarrier] = React.useState<string>();
    const [targetCarrier2, setTargetCarrier2] = React.useState<string>();

    const [targetPlan, setTargetPlan] = React.useState<string>();
    const [targetPlan2, setTargetPlan2] = React.useState<string>();

    const [allInsurance, allInsuranceLoading, fetchAllInsurance] = useInsurance();
    const [showEmptyStateError, setShowEmptyStateError] = React.useState(false);

    const [preferMethod, setPreferMethod] = React.useState<string[]>([TEXT_MESSAGE, PHONE_CALL, EMAIL]);

    const stateCarrier = targetState ? allInsurance.find((item) => {
        return item.state === targetState.label || item.state === targetState.value;
    }) : undefined;

    const stateCarrier2 = targetState ? allInsurance.find((item) => {
        return item.state === targetState.label || item.state === targetState.value;
    }) : undefined;

    const carrierOption: TCarrier[] = stateCarrier?.carriers || [];
    const carrierOption2: TCarrier[] = stateCarrier2?.carriers || [];

    const planOption: string[] = targetCarrier ? stateCarrier?.carriers.find((item) => {
        return item.name === targetCarrier;
    })?.plans || [] : [];

    const planOption2: string[] = targetCarrier2 ? stateCarrier2?.carriers.find((item) => {
        return item.name === targetCarrier2;
    })?.plans || [] : [];

    const options = [
        { label: TEXT_MESSAGE, value: TEXT_MESSAGE, key: TEXT_MESSAGE },
        { label: PHONE_CALL, value: PHONE_CALL, key: PHONE_CALL },
        { label: EMAIL, value: EMAIL, key: EMAIL },
    ];

    const scrollToState = () => {
        const target = document.getElementById('state-input');
        try {
            target?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const showBasicInfo = !item || !type || (item && type === 1);
    const showPaymentInfo = !item || !type || (item && type === 2);

    React.useEffect(() => {
        if (insuranceChecked) {
            const firstName = form.getFieldValue("firstName");
            const lastName = form.getFieldValue("lastName");
            const iFirstName = form.getFieldValue("insuranceFirstName");
            const iLastName = form.getFieldValue("insuranceFirstName");
            if (!iFirstName) {
                form.setFieldsValue({ insuranceFirstName: firstName });
            }
            if (!iLastName) {
                form.setFieldsValue({ insuranceLastName: lastName });
            }
        }
    }, [insuranceChecked])

    // const [myChannels] = useMyListedChannels();
    const onSubmit = async () => {
        try {
            const createTime = formatDate(dayjs());

            const formValues: FormProspect = await form.validateFields();

            if (!formValues.tel && !formValues.email) {
                message.error('Please enter email or phone number');
                return;
            }
            let billing = '';
            if (selfPayChecked && insuranceChecked) {
                billing = `${EBillingType.SELF_PAY},${EBillingType.INSURANCE}`;
            } else if (selfPayChecked) {
                billing = EBillingType.SELF_PAY;
            } else if (insuranceChecked) {
                billing = EBillingType.INSURANCE;
            }
            const data: Prospect = {
                preferMethod: formValues.preferMethod!.join(','),
                birthday: formValues.birthday ? dayjs(formValues.birthday, 'MM/DD/YYYY').format('YYYY-MM-DD') : undefined,
                type: item?.type || EProspectType.PATIENT,
                address: formValues.address,
                billing,
                city: formValues.city,
                email: formValues.email,
                firstName: formValues.firstName,
                gender: formValues.gender,
                lastName: formValues.lastName,
                notes: formValues.notes,
                state: formValues.state,
                tel: formValues.tel,
                zip: formValues.zip,
                idFront: formValues.idFront,
                idBack: formValues.idBack,
                sendInvitationEmail: formValues.sendInvitationEmail,
            };

            if (selfPayChecked) {
                data.cardNum = formValues.cardNum;
                data.cardExpirationDate = formValues.cardExpirationDate?.format('MM/YY');
                data.cardCvc = formValues.cardCvc;
            }

            if (insuranceChecked) {
                data.insurances = [];
                const data1: TProspectInsurance = {
                    groupId: formValues.groupId,
                    memberId: formValues.memberId,
                    front: formValues.front,
                    backend: formValues.backend,
                    carrier: targetCarrier || '',
                    plan: targetPlan || '',
                    sort: 1,
                    firstName: formValues.insuranceFirstName,
                    lastName: formValues.insuranceLastName,
                };
                if (isEdit) {
                    if (item && item.insurances && item.insurances?.length > 0) {
                        const mainInsurance = item.insurances[0];
                        data1.id = mainInsurance.id;
                        if (data1.backend === mainInsurance.backend) {
                            data1.backend = null;
                        }
                        if (data1.front === mainInsurance.front) {
                            data1.front = null;
                        }
                    }
                }
                data.insurances.push(data1);
                if (showSecondInsurance) {
                    const data2: TProspectInsurance = {
                        groupId: formValues.groupId2,
                        memberId: formValues.memberId2,
                        front: formValues.front2,
                        backend: formValues.backend2,
                        carrier: targetCarrier2 || '',
                        plan: targetPlan2 || '',
                        sort: 2,
                    };
                    if (isEdit) {
                        if (item && item.insurances && item.insurances?.length > 1) {
                            const secondInsurance = item.insurances[1];
                            data2.id = secondInsurance.id;
                            if (data2.backend === secondInsurance.backend) {
                                data2.backend = null;
                            }
                            if (data2.front === secondInsurance.front) {
                                data2.front = null;
                            }
                        }
                    }
                    data.insurances.push(data2);
                }
            }

            setSubmiting(true);
            if (isEdit) {
                data.id = item.id;
                data.sendInvitationEmail = item.sendInvitationEmail;
                if (item.idBack === data.idBack) {
                    data.idBack = null;
                }
                if (item.idFront === data.idFront) {
                    data.idFront = null;
                }
                const result = await updateProspect(item.id!, data);
                if (result.error) {
                    message.error(result.error);
                } else {
                    message.success('Prospect info has updated');
                    if (onSuccess) {
                        onSuccess();
                    }
                }
            } else {
                data.createTime = createTime;
                const result = await createProspect(data);
                if (result.error) {
                    //message.error(result.error);

                } else {
                    const id = result.data.data;
                    message.success('Prospect has added');
                    if (onSuccess) {
                        onSuccess(id);
                    }
                }
            }
        } catch (e: any) {
            if (e.errorFields) {
                //form error
                return;
            }
            //const msg = e?.toString?.() || 'data error';
            //message.error(msg);
        } finally {
            setSubmiting(false);
        }
    };

    React.useEffect(() => {
        if (item && stateOption && allInsurance && stateOption.length > 0 && allInsurance.length > 0) {
            const formVal: FormProspect = {
                firstName: item.firstName,
                lastName: item.lastName,
                email: item.email,
                //@ts-ignore
                birthday: item.birthday ? dayjs(item.birthday, 'YYYY-MM-DD').format('MM/DD/YYYY') : undefined,
                tel: item.tel,
                address: item.address,
                city: item.city,
                state: item.state,
                zip: item.zip,
                gender: item.gender,
                notes: item.notes,
                idBack: item.idBack!,
                idFront: item.idFront!,
                //@ts-ignore
                preferMethod: item.preferMethod?.split(',') || [],
                sendInvitationEmail: item.sendInvitationEmail,
                insuranceFirstName: item.insurances?.[0]?.firstName,
                insuranceLastName: item.insurances?.[0]?.lastName,

            };

            if (item.billing?.includes(EBillingType.SELF_PAY)) {
                setSelfPayChecked(true);
                formVal.cardNum = item.cardNum || item.patientCardNum || '';
                const _cardExpirationDate = item.cardExpirationDate || item.patientCardExpirationDate;
                formVal.cardExpirationDate = _cardExpirationDate ? dayjs(_cardExpirationDate, 'MM/YY') : undefined;
                formVal.cardCvc = item.cardCvc || item.patientCardCvc || '';
            }

            if (item.state) {
                const st = stateOption?.find((item) => {
                    return item.value === item.value || item.label === item.label;
                });
                setTargetState(st);
            }
            if (item.insurances && item.insurances.length > 0) {
                setInsuranceChecked(true);
                item.insurances.sort((a, b) => {
                    if (!a.sort) {
                        return 1;
                    }
                    if (!b.sort) {
                        return -1;
                    }
                    return a.sort - b.sort;
                });
                if (item.insurances.length > 0) {
                    const mainInsurance = item.insurances[0];
                    setTargetCarrier(mainInsurance.carrier);
                    setTargetPlan(mainInsurance.plan);
                    formVal.groupId = mainInsurance.groupId;
                    formVal.memberId = mainInsurance.memberId;
                    formVal.front = mainInsurance.front!;
                    formVal.backend = mainInsurance.backend!;
                    formVal.carrier = mainInsurance.carrier;
                    formVal.plan = mainInsurance.plan;
                    formVal.insuranceFirstName = mainInsurance.firstName;
                    formVal.insuranceLastName = mainInsurance.lastName;
                }
                if (item.insurances.length > 1) {
                    const secondInsurance = item.insurances[1];
                    setShowSecondInsurance(true);
                    setTargetCarrier2(secondInsurance.carrier);
                    setTargetPlan2(secondInsurance.plan);
                    formVal.groupId2 = secondInsurance.groupId;
                    formVal.memberId2 = secondInsurance.memberId;
                    formVal.front2 = secondInsurance.front!;
                    formVal.backend2 = secondInsurance.backend!;
                    formVal.carrier2 = secondInsurance.carrier;
                    formVal.plan2 = secondInsurance.plan;
                }
            }
            form.setFieldsValue(formVal);
        }
    }, [item, stateOption, allInsurance]);

    return (
        <Modal
            title={isEdit ? 'Edit the client' : 'Create new client'}
            closable
            className={commonS.modalFixHeightWrap}
            width="665px"
            onCancel={() => {
                onCannel?.();
            }}
            okText="Save"
            open={show}
            onOk={onSubmit}
            destroyOnClose
            okButtonProps={{ loading: submiting }}
            zIndex={99999}
            wrapClassName={wrapClassName || ''}
        >
            <Form
                form={form}
                name="basic"
                className={commonS.formStyle1}
                initialValues={{
                    remember: true,
                    preferMethod,
                    sendInvitationEmail: true,
                }}
                autoComplete="off"
                layout="vertical"
                scrollToFirstError
            >
                <div className={s.modalWrap}>
                    <div className={`${s.basicWrap} ${showBasicInfo ? s.basicWrapShow : ''}`} >
                        <h3 style={{ border: 'none', paddingTop: 0 }}>Basic information</h3>
                        <div className={s.row}>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '300px' }}
                                    label="First name"
                                    name={['firstName']}
                                    rules={[
                                        { required: true, message: 'First name is required' },
                                    ]}
                                >
                                    <Input
                                        maxLength={25} placeholder="" />
                                </Form.Item>
                            </div>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '300px' }}
                                    label="Last name"
                                    name={['lastName']}
                                    rules={[{ required: true, message: 'Last name is required' }]}
                                >
                                    <Input max={25} placeholder="" />
                                </Form.Item>
                            </div>
                        </div>
                        <div className={s.row}>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '300px' }}
                                    label="Phone number"
                                    name={['tel']}
                                    validateFirst
                                    rules={[
                                        { required: true, message: REQUIRED_FIELD },
                                        FormValidationHelper.validateUSPhoneNumber(
                                            'Please enter a 10-digit phone number',
                                        ),
                                    ]}
                                >
                                    <UsPhoneInput />
                                </Form.Item>
                            </div>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '300px' }}
                                    label="Email"
                                    name={['email']}
                                    validateFirst
                                    rules={[{ type: 'email', message: REQUIRED_FIELD }]}
                                >
                                    <Input />
                                </Form.Item>
                            </div>
                        </div>
                        {/* <div className={s.row}>
                        <div className={s.rowItem}>
                            <Form.Item
                                style={{ width: '360px' }}
                                label="Select a channel:"
                                name={['channelId']}
                                validateFirst
                                rules={[{ required: true, message: 'Channel is required' }]}
                            >
                                <MyChannelSelect showOthers />
                            </Form.Item>
                        </div>
                    </div> */}
                        <h3 className={s.h3Btm}>Contact information</h3>

                        <div className={s.row}>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '360px' }}
                                    label="Address"
                                    name="address"
                                    rules={[{ required: false, message: 'Address is required' }]}
                                >
                                    <Input />
                                </Form.Item>
                            </div>
                        </div>
                        <div className={s.row}>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '180px' }}
                                    label="City"
                                    name="city"
                                    rules={[{ required: false, message: 'City is required' }]}
                                >
                                    <Input />
                                </Form.Item>
                            </div>
                            <div className={s.rowItem} id="state-input">
                                <Form.Item
                                    style={{ width: '180px' }}
                                    label="State"
                                    name="state"
                                    rules={[{ required: false, message: 'State is required' }]}
                                >
                                    <StateSelect
                                        status={showEmptyStateError ? 'error' : undefined}
                                        onChange={(val) => {
                                            const st = stateOption?.find((item) => {
                                                return item.value === val || item.label === val;
                                            });
                                            setTargetState(st);
                                        }}
                                    />
                                </Form.Item>
                            </div>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '80px' }}
                                    label="ZIP code"
                                    name="zip"
                                    rules={[{ required: false, message: 'ZIP code is required' }]}
                                >
                                    <Input />
                                </Form.Item>
                            </div>
                        </div>
                        <div className={s.row}>
                            <div className={s.rowItem} style={{ width: '100%' }}>
                                <Form.Item
                                    label="Preferred methods of contact"
                                    name={['preferMethod']}
                                >
                                    <Checkbox.Group
                                        options={options.map((op) => {
                                            return {
                                                ...op,
                                                disabled:
                                                    preferMethod.includes(op.value) &&
                                                    preferMethod.length === 1,
                                            };
                                        })}
                                        onChange={(e) => {
                                            setPreferMethod(e as string[]);
                                        }}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <h3 className={s.h3Btm}>Personal Information</h3>
                        <div className={s.row}>
                            {/* <div className={s.rowItem}>
                            <Form.Item
                                style={{ width: '300px' }}
                                label="Birthday"
                                name={['birthday']}
                                rules={[{ required: false, message: 'Birthday is required' }]}
                            >
                                <DatePicker
                                    defaultPickerValue={
                                        item?.birthday ? undefined : dayjs().add(-18, 'years')
                                    }
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </div> */}
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '300px' }}
                                    label="Birthday"
                                    name={['birthday']}
                                    rules={[{
                                        required: false, message: REQUIRED_FIELD,
                                    },
                                    FormValidationHelper.validateBirthday(
                                        'Invalid date format',
                                    ),
                                    ]}
                                >
                                    <BirthdayInput
                                        style={{ width: '100%' }}
                                    />
                                </Form.Item>
                            </div>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '300px' }}
                                    label="Gender"
                                    name={['gender']}
                                    rules={[{ required: false, message: REQUIRED_FIELD }]}
                                >
                                    <GenderSelect />
                                </Form.Item>
                            </div>
                        </div>
                        <h4>ID</h4>
                        <div className={s.subTitle}>Upload photos of your ID</div>
                        <div className={s.row}>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '260px' }}
                                    label=""
                                    name={['idFront']}
                                    rules={[{ required: false, message: 'Id photo is required' }]}
                                >
                                    <FileUploadPrivate
                                        accept="image/*"
                                        uploadType="PROSPECT_IDENTITY"
                                        notNeedSign
                                    />
                                </Form.Item>
                            </div>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '260px' }}
                                    label=""
                                    name={['idBack']}
                                    rules={[{ required: false, message: 'Id photo is required' }]}
                                >
                                    <FileUploadPrivate
                                        accept="image/*"
                                        uploadType="PROSPECT_IDENTITY"
                                        notNeedSign
                                    />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className={`${s.paymentWrap} ${showPaymentInfo ? s.paymentWrapShow : ''}`} >
                        {
                            showBasicInfo && <div className={s.line} />
                        }
                        <div className={s.row}>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '360px' }}
                                    label=""
                                    fieldKey="checked"
                                    name={['selfPay']}
                                >
                                    <Checkbox
                                        onChange={(e) => {
                                            setSelfPayChecked(e.target.checked);
                                        }}
                                        checked={selfPayChecked}
                                        style={{ fontWeight: 500 }}
                                    >
                                        Self-pay
                                    </Checkbox>
                                </Form.Item>
                            </div>
                        </div>
                        {selfPayChecked && (
                            <div className={s.subModule}>
                                <div className={s.row}>
                                    <div className={s.rowItem}>
                                        <Form.Item
                                            style={{ width: '200px' }}
                                            label="Card number"
                                            name={['cardNum']}
                                            validateFirst
                                            rules={[{ required: false, message: REQUIRED_FIELD }]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </div>
                                    <div className={s.rowItem}>
                                        <Form.Item
                                            style={{ width: '140px' }}
                                            label="Expiration date"
                                            name={['cardExpirationDate']}
                                            rules={[
                                                {
                                                    required: false,
                                                    message: REQUIRED_FIELD,
                                                },
                                            ]}
                                        >
                                            <DatePicker format="MM/YY" style={{ width: '100%' }} />
                                        </Form.Item>
                                    </div>
                                    <div className={s.rowItem}>
                                        <Form.Item
                                            style={{ width: '112px' }}
                                            label="CVC"
                                            name={['cardCvc']}
                                            rules={[
                                                {
                                                    required: false,
                                                    message: REQUIRED_FIELD,
                                                },
                                            ]}
                                        >
                                            <InputNumber controls={false} type="number" step={0} />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className={s.line} />
                        <div className={s.rowItem}>
                            <Form.Item
                                style={{ width: '360px' }}
                                label=""
                                fieldKey="checked"
                                name={['insurance']}
                            >
                                <Checkbox
                                    checked={insuranceChecked}
                                    disabled={!targetState}
                                    onChange={(e) => {
                                        setInsuranceChecked(e.target.checked);
                                    }}
                                    style={{ fontWeight: 500 }}
                                >
                                    Insurance
                                </Checkbox>
                            </Form.Item>
                        </div>
                        {!targetState && (
                            <div className={s.emptyState}>
                                <div className={s.eLeft}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11V14C9 14.5523 9.44772 15 10 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V10C11 9.44772 10.5523 9 10 9H9Z"
                                            fill="#60A5FA"
                                        />
                                    </svg>
                                    Select the client's state first, then choose an insurance.
                                </div>
                                <div
                                    onClick={() => {
                                        setShowEmptyStateError(true);
                                        scrollToState();
                                    }}
                                    className={s.eRight}
                                >
                                    Select state →
                                </div>
                            </div>
                        )}
                        {insuranceChecked && (
                            <div className={s.subModule}>
                                <div className={s.row}>
                                    <div className={s.rowItem}>
                                        <Form.Item
                                            style={{ width: '300px' }}
                                            label="Member legal first name"
                                            name={['insuranceFirstName']}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Member legal first name is required',
                                                },
                                            ]}
                                        >
                                            <Input maxLength={25} placeholder="" />
                                        </Form.Item>
                                    </div>
                                    <div className={s.rowItem}>
                                        <Form.Item
                                            style={{ width: '300px' }}
                                            label="Member legal last name"
                                            name={['insuranceLastName']}
                                            rules={[
                                                { required: true, message: 'Member legal last name is required' },
                                            ]}
                                        >
                                            <Input maxLength={25} placeholder="" />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.rowItem}>
                                        <Form.Item
                                            style={{ width: '300px' }}
                                            label="Insurance carrier"
                                            name={['carrier']}
                                            validateFirst
                                            rules={[
                                                { required: true, message: 'Carrier is required' },
                                            ]}
                                        >
                                            <AutoComplete
                                                style={{ width: '100%' }}
                                                options={carrierOption?.map((item) => {
                                                    return {
                                                        value: item.name,
                                                    };
                                                })}
                                                value={targetCarrier}
                                                placeholder="Please select or input"
                                                filterOption={(inputValue, option) => {
                                                    return !!option?.value
                                                        .toLowerCase()
                                                        .includes(inputValue.toLowerCase());
                                                }}
                                                onChange={(val) => {
                                                    setTargetCarrier(val);
                                                }}
                                            >
                                                <Input allowClear />
                                            </AutoComplete>
                                            {/* <InsuranceSelect
                                        showOthers
                                        onChange={(val) => {
                                            if (val === 'others') {
                                                setIsOthers(true);
                                            } else {
                                                setIsOthers(false);
                                            }
                                        }}
                                    /> */}
                                        </Form.Item>
                                    </div>
                                    <div className={s.rowItem}>
                                        <Form.Item
                                            style={{ width: '300px' }}
                                            label="Insurance plan"
                                            name={['plan']}
                                            validateFirst
                                            rules={[{ required: false, message: REQUIRED_FIELD }]}
                                        >
                                            <AutoComplete
                                                style={{ width: '100%' }}
                                                options={planOption?.map((item) => {
                                                    return {
                                                        value: item,
                                                    };
                                                })}
                                                value={targetPlan}
                                                placeholder="Please select or input"
                                                filterOption={(inputValue, option) => {
                                                    return !!option?.value
                                                        .toLowerCase()
                                                        .includes(inputValue.toLowerCase());
                                                }}
                                                onChange={(val) => {
                                                    setTargetPlan(val);
                                                }}
                                            >
                                                <Input allowClear />
                                            </AutoComplete>
                                            {/* <InsuranceSelect
                                        showOthers
                                        onChange={(val) => {
                                            if (val === 'others') {
                                                setIsOthers(true);
                                            } else {
                                                setIsOthers(false);
                                            }
                                        }}
                                    /> */}
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.rowItem}>
                                        <Form.Item
                                            style={{ width: '300px' }}
                                            label="Member ID"
                                            name={['memberId']}
                                            validateFirst
                                            rules={[{ required: true, message: REQUIRED_FIELD }]}
                                        >
                                            <Input allowClear />
                                        </Form.Item>
                                    </div>
                                    <div className={s.rowItem}>
                                        <Form.Item
                                            style={{ width: '300px' }}
                                            label="Group ID"
                                            name={['groupId']}
                                            validateFirst
                                        >
                                            <Input allowClear />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className={s.row}>
                                    <div className={s.rowItem}>
                                        <Form.Item
                                            style={{ width: '260px' }}
                                            label=""
                                            name={['front']}
                                            rules={[{ required: true, message: REQUIRED_FIELD }]}
                                        >
                                            <FileUploadPrivate
                                                accept="image/*"
                                                uploadType="PROSPECT_INSURANCE"
                                                notNeedSign
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className={s.rowItem}>
                                        <Form.Item
                                            style={{ width: '260px' }}
                                            label=""
                                            name={['backend']}
                                            rules={[{ required: true, message: REQUIRED_FIELD }]}
                                        >
                                            <FileUploadPrivate
                                                accept="image/*"
                                                uploadType="PROSPECT_INSURANCE"
                                                notNeedSign
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                                {showSecondInsurance && (
                                    <div className={s.second}>
                                        <div className={s.secondTitle}>
                                            <span style={{ marginBottom: '16px' }}>Secondary insurance</span>
                                            <span
                                                onClick={() => {
                                                    setShowSecondInsurance(false);
                                                }}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M19 7L18.1327 19.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224C6.81296 21 5.94208 20.1891 5.86732 19.1425L5 7M10 11V17M14 11V17M15 7V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V7M4 7H20"
                                                        stroke="#6B7280"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </span>
                                        </div>
                                        <div className={s.row}>
                                            <div className={s.rowItem}>
                                                <Form.Item
                                                    style={{ width: '300px' }}
                                                    label="Insurance carrier"
                                                    name={['carrier2']}
                                                    validateFirst
                                                    rules={[
                                                        { required: true, message: 'Carrier is required' },
                                                    ]}
                                                >
                                                    <AutoComplete
                                                        style={{ width: '100%' }}
                                                        options={carrierOption2?.map((item) => {
                                                            return {
                                                                value: item.name,
                                                            };
                                                        })}
                                                        placeholder="Please select or input"
                                                        filterOption={(inputValue, option) => {
                                                            return !!option?.value
                                                                .toLowerCase()
                                                                .includes(inputValue.toLowerCase());
                                                        }}
                                                        onChange={(val) => {
                                                            setTargetCarrier2(val);
                                                        }}
                                                        value={targetCarrier2}
                                                    >
                                                        <Input allowClear />
                                                    </AutoComplete>
                                                </Form.Item>
                                            </div>
                                            <div className={s.rowItem}>
                                                <Form.Item
                                                    style={{ width: '300px' }}
                                                    label="Member ID"
                                                    name={['memberId2']}
                                                    validateFirst
                                                    rules={[{ required: true, message: REQUIRED_FIELD }]}
                                                >
                                                    <Input allowClear />
                                                </Form.Item>
                                            </div>
                                            {/* <div className={s.rowItem}>
                                                <Form.Item
                                                    style={{ width: '240px' }}
                                                    label="Insurance plan"
                                                    name={['plan2']}
                                                    validateFirst
                                                    rules={[{ required: false, message: REQUIRED_FIELD }]}
                                                >
                                                    <AutoComplete
                                                        style={{ width: '100%' }}
                                                        options={planOption2?.map((item) => {
                                                            return {
                                                                value: item,
                                                            }
                                                        })}
                                                        placeholder="Please select or input"
                                                        filterOption={(inputValue, option) => {
                                                            return !!(option?.value.toLowerCase().includes(inputValue.toLowerCase()))
                                                        }}
                                                        onChange={(val) => {
                                                            setTargetPlan2(val);
                                                        }}
                                                        value={targetPlan2}
                                                    >
                                                        <Input allowClear />
                                                    </AutoComplete>
                                                </Form.Item>
                                            </div> */}
                                        </div>
                                        <div className={s.row}>
                                            <div className={s.rowItem}>
                                                <Form.Item
                                                    style={{ width: '300px' }}
                                                    label="Group ID"
                                                    name={['groupId2']}
                                                    validateFirst
                                                >
                                                    <Input allowClear />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        {/* <div className={s.row}>
                                            <div className={s.rowItem}>
                                                <Form.Item
                                                    style={{ width: '240px' }}
                                                    label=""
                                                    name={['front2']}
                                                    rules={[{ required: false, message: REQUIRED_FIELD }]}
                                                >
                                                    <FileUpload
                                                        accept="image/*"
                                                        acceptTypeStr='PNG, JPG, GIF'
                                                    />
                                                </Form.Item>
                                            </div>
                                            <div className={s.rowItem}>
                                                <Form.Item
                                                    style={{ width: '240px' }}
                                                    label=""
                                                    name={['backend2']}
                                                    rules={[{ required: false, message: REQUIRED_FIELD }]}
                                                >
                                                    <FileUpload />
                                                </Form.Item>
                                            </div>
                                        </div> */}
                                    </div>
                                )}
                                {!showSecondInsurance && (
                                    <div
                                        className={s.addSecond}
                                        onClick={() => {
                                            setShowSecondInsurance(true);
                                        }}
                                    >
                                        <span>Add secondary insurance</span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    {!isEdit && !isKlarity && (
                        <>
                            <h3 className={s.h3Btm}>Invitation to patient portal</h3>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '80%' }}
                                    label=""
                                    name={['sendInvitationEmail']}
                                >
                                    <Radio.Group
                                        options={[
                                            {
                                                value: true,
                                                label:
                                                    'Send client an invitation to sign up for the patient portal',
                                            },
                                            {
                                                value: false,
                                                label:
                                                    'Don’t send client an invitation to sign up for the patient portal',
                                            },
                                        ]}
                                    />
                                </Form.Item>
                            </div>
                        </>
                    )}
                    {!isEdit && (
                        <>
                            <h3 className={s.h3Btm}>Notes</h3>
                            <div className={s.rowItem}>
                                <Form.Item
                                    style={{ width: '80%' }}
                                    label=""
                                    name={['notes']}
                                    validateFirst
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Carrier number is required',
                                        },
                                    ]}
                                >
                                    <InputTextArea rows={5} />
                                </Form.Item>
                            </div>
                        </>
                    )}
                </div>
            </Form>
        </Modal >
    );
};

export default AddAndUpdateProspects;
